import { badgeUrls } from '@geovelo-frontends/commons';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { environment } from '../../environment';
import useTracker from '../../hooks/tracker';

export function GooglePlayBadge({ height }: { height: number }): React.JSX.Element {
  const { t } = useTranslation();
  const { trackEvent } = useTracker();

  return (
    <Box
      component="a"
      display="inline-block"
      height={height}
      href={`${environment.android.storeUrls.fr}&referrer=utm_source%3Dwebsite`}
      onClick={() => {
        trackEvent('Google Play Badge Clicked');
      }}
      overflow="hidden"
      rel="noreferrer"
      target="_blank"
    >
      <img
        alt={t('commons.app_badge_labels.google_play') || ''}
        height={height}
        src={badgeUrls.fr.android}
        width="auto"
      />
    </Box>
  );
}
